export const Routes = {
	verify: "/verify/:uid/:code/:lookupId",
	verifyEmail: "/verify-email",
	account: "/account/",
};
